import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Flex } from "../Flex";
/**
 * @trackcomponent
 */ export var Column = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var _props_direction;
    return /*#__PURE__*/ _jsx(Flex, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        // HACK: Column shouldn't accept direction, but it's passed by builder.io and possibly other sources. Support it for now.
        direction: (_props_direction = props.direction) !== null && _props_direction !== void 0 ? _props_direction : "column"
    }));
});
